export const REQUEST_RENDERING_SUCCESS = 'session/REQUEST_RENDERING_SUCCESS'
export const REQUEST_RENDERING_FAILURE = 'session/REQUEST_RENDERING_FAILURE'
export const REQUEST_RENDERING_STARTED = 'session/REQUEST_RENDERING_STARTED'
export const REQUEST_RENDERING_AMOUNT_WARNING = 'session/REQUEST_RENDERING_AMOUNT_WARNING'
